import React from "react";
interface IProps {
  onClick ?: () => void
}
const PdfIcon = ({onClick} :IProps) => {
  return (
<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.1842 2.94727H14.8158V4.21042H2.1842V2.94727Z" fill="#424242"/>
<path d="M0.0789795 8.84203H16.9211V5.89466C16.9211 4.96834 16.1632 4.21045 15.2369 4.21045H1.76319C0.836874 4.21045 0.0789795 4.96834 0.0789795 5.89466V8.84203Z" fill="#616161"/>
<path d="M1.76319 13.4738H15.2369C16.1632 13.4738 16.9211 12.7159 16.9211 11.7896V8.42114H0.0789795V11.7896C0.0789795 12.7159 0.836874 13.4738 1.76319 13.4738Z" fill="#424242"/>
<path d="M15.2368 6.31574C15.4694 6.31574 15.6579 6.12723 15.6579 5.89469C15.6579 5.66214 15.4694 5.47363 15.2368 5.47363C15.0043 5.47363 14.8158 5.66214 14.8158 5.89469C14.8158 6.12723 15.0043 6.31574 15.2368 6.31574Z" fill="#00E676"/>
<path d="M3.02637 0H13.9737V4.21053H3.02637V0Z" fill="#90CAF9"/>
<path d="M14.1842 11.3684H2.81578C2.47894 11.3684 2.1842 11.0736 2.1842 10.7368C2.1842 10.4 2.47894 10.1052 2.81578 10.1052H14.1842C14.521 10.1052 14.8158 10.4 14.8158 10.7368C14.8158 11.0736 14.521 11.3684 14.1842 11.3684Z" fill="#242424"/>
<path d="M3.02637 11.3684H13.9737V16H3.02637V11.3684Z" fill="#90CAF9"/>
<path d="M3.02637 10.5264H13.9737V11.3685H3.02637V10.5264Z" fill="#42A5F5"/>
<path d="M5.13159 12.2104H12.2895V13.0526H5.13159V12.2104ZM5.13159 13.8947H10.6053V14.7368H5.13159V13.8947Z" fill="#1976D2"/>
</svg>


  );
};

export default PdfIcon;
